const scrollLock = require('scroll-lock');
const isbot = require('isbot');

function getAge(birthdate) {
  const today = new Date();
  let age = today.getFullYear() - birthdate.getFullYear();
  const m = today.getMonth() - birthdate.getMonth();

  if (m < 0 || (m === 0 && today.getDate() < birthdate.getDate())) {
    age--;
  }

  return age;
}

/**
 * @class AgeGate
 * @classdesc The class for site Age Gate.
 *
 * @extends Core.Component
 */
export default class AgeGate extends Core.Component {
  constructor(el, context) {
    super(el, context);
    this._ageGate = this.el.querySelector('[data-age-gate]');

    if (!this._ageGate) return; // We're not enabled

    this._ageGateForm = this._ageGate.querySelector('[data-age-gate-form]');
    this._ageGateErrorEl = this._ageGateForm.querySelector('[data-age-gate-error]');
    this._requiredAge = this._ageGateForm.dataset.requiredAge;
    this._ageGateForm.addEventListener('submit', this._onFormSubmit.bind(this));

    if (isbot(navigator.userAgent)) {
      this.close();
    } else if (this._ageGate.style.display === '') {
      this.open();
    }
  }

  open() {
    scrollLock.disablePageScroll();
    this._ageGate.style.display = '';
  }

  close() {
    scrollLock.enablePageScroll();
    this._ageGate.style.display = 'none';
  }

  _onFormSubmit(event) {
    event.preventDefault();
    event.stopPropagation();

    const data = new FormData(event.target);
    const day = data.get('day');
    const month = data.get('month');
    const year = data.get('year');

    if (day === '' || month === '' || year === '') return;

    const age = getAge(new Date(year, month, day));

    if (age >= this._requiredAge) {
      this.close();
      sessionStorage.setItem('age-gate', age);
    } else {
      this._ageGateErrorEl.style.display = '';
    }
  }
}
